import {Component, NgZone, ViewChild} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {NgIf} from "@angular/common";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {UserService} from "../services/user.service";
import firebase from "firebase/compat/app";
import {TeacherService} from "../services/teacher.service";
import {Teacher} from "../interfaces/teacher";
import {Grant} from "../interfaces/grant";
import {GrantsFormComponent} from "../grants-form/grants-form.component";
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-grants-details',
  templateUrl: './grants-details.component.html',
  standalone: true,
  imports: [
    FormsModule,
    DatePipe,
    NgIf,
    RouterLink,
    GrantsFormComponent
  ],
  styleUrl: './grants-details.component.css'
})
export class GrantsDetailsComponent {
  constructor(private route: ActivatedRoute, public userService: UserService, private ngZone: NgZone, private router: Router, private teacherService: TeacherService) {
  }

  grantId!: string;
  grant!: Grant;
  isEditing = false;
  teacher: Teacher | null = null;
  grantExists = true;
  @ViewChild(GrantsFormComponent) formComponent!: GrantsFormComponent;

  async ngOnInit() {
    this.teacher = await this.teacherService.getTeacher();
    this.grantId = this.route.snapshot.paramMap.get("id")!;
    await this.loadGrant();
  }

  async loadGrant() {
    try {
      const docSnap = await firebase
        .firestore()
        .collection("grant")
        .doc(this.grantId)
        .get();

      if (docSnap.exists) {
        this.grant = {id: docSnap.id, ...docSnap.data()} as Grant;
      } else {
        this.grantExists = false;
      }
    } catch (err) {
      this.grantExists = false;
    }
  }

  toggleEditing() {
    this.isEditing = !this.isEditing;
    if (this.isEditing) {
      // wait for the form
      setTimeout(() => {
        if (this.formComponent && this.grant) {
          this.formComponent.initializeForm(this.grant);
        }
      }, 0);
    }
  }

  onFormUpdated(updatedGrant: Grant) {
    this.grant = updatedGrant;
    this.isEditing = false;
  }

  isDeleting = false;

  deleteGrant() {
    if (!confirm("Are you sure you want to delete this grant?")) return;
    this.isDeleting = true;

    return firebase.firestore()
      .collection('grant')
      .doc(this.grant.id)
      .set({isDeleted: true}, {merge: true})
      .then(() => {
        this.grant.isDeleted = true;
        this.isDeleting = false;
      })
      .catch(err => {
        console.error(err);
        this.isDeleting = false;
      });
  }

  undeleteGrant() {
    if (!confirm("Are you sure you want to undelete this grant?")) return;
    this.isDeleting = true;

    return firebase.firestore()
      .collection('grant')
      .doc(this.grant.id)
      .set({isDeleted: false}, {merge: true})
      .then(() => {
        this.grant.isDeleted = false;
        this.isDeleting = false;
      })
      .catch(err => {
        console.error(err);
        this.isDeleting = false;
      });
  }

  formatPhone(value: string): string {
    if (!value) return '';
    const digits = value.replace(/\D/g, '');
    if (digits.length !== 10) return value;
    return `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6)}`;
  }
}
